// SPDX-License-Identifier: AGPL-3.0-or-later
export const en = {
    "app.name": "{app}",
    "app.tagline": "Know the season you're in. Plan for the ones ahead.",
    "nav.main": "Main navigation",
    "nav.skip": "Skip to main content",
    "nav.dashboard": "Dashboard",
    "nav.budgets": "Budgets",
    "nav.import": "Import",
    "nav.transactions": "Transactions",
    "tx.empty": "No transactions yet.",
    "tx.goImport": "Import a bank CSV",
    "tx.filters": "Filters",
    "tx.month": "Month",
    "tx.allMonths": "All months",
    "tx.account": "Account",
    "tx.allAccounts": "All accounts",
    "tx.search": "Search descriptions",
    "tx.reviewOnly": "Only ones needing a category ({count})",
    "tx.count": "{count} transactions",
    "tx.allSorted": "Every transaction has a category.",
    "tx.noMatch": "No transactions match these filters.",
    "tx.bulkLabel": "Change several at once",
    "tx.selected": "{count} selected",
    "tx.bulkCategory": "Category for the selected transactions",
    "tx.bulkPick": "Pick a category",
    "tx.bulkApply": "Set category for {count}",
    "tx.bulkDone": "Set {count} transactions to {category}.",
    "tx.selectAll": "Select all shown",
    "tx.select": "Select {description}",
    "tx.showMore": "Show {count} more",
    "tx.learnHint": "When you pick a category, future imports from the same payee get it too.",
    "tx.waiting": "{count} transactions need a category, so they don't count toward any budget line yet.",
    "tx.review": "Sort them now",
    "nav.events": "Events",
    "events.add": "Add an event",
    "events.edit": "Edit event",
    "events.addOn": "Add an event on {date}",
    "events.saved": "Saved {title}.",
    "events.deleted": "Deleted {title}.",
    "events.confirmDelete": "Delete “{title}”? Every repeat of it goes too.",
    "events.upcoming": "Coming up",
    "events.none": "No events yet. Add bills, renewals or birthdays so they show here and in your calendar.",
    "events.nothingSoon": "Nothing in the next {days} days.",
    "events.next30": "Expected costs in the next 30 days: {amount}",
    "events.repeat": "Repeats",
    "events.repeat.none": "Doesn't repeat",
    "events.repeat.weekly": "Every week",
    "events.repeat.biweekly": "Every two weeks",
    "events.repeat.monthly": "Every month",
    "events.repeat.yearly": "Every year",
    "events.editShort": "Edit",
    "events.editNamed": "Edit {title}",
    "events.delete": "Delete event",
    "events.prevMonth": "Previous month",
    "events.nextMonth": "Next month",
    "events.keys": "Arrow keys move by day and week, Page Up and Page Down by month. Enter adds an event on the chosen day.",
    "events.dayNone": "No events",
    "events.dayCount": "{count} event(s)",
    "events.title": "Title",
    "events.date": "Date",
    "events.until": "Last date (optional)",
    "events.amount": "Expected cost (optional)",
    "events.category": "Budget category (optional)",
    "events.noCategory": "None",
    "events.notes": "Notes (never leave this device unencrypted)",
    "events.hidden": "Keep this off the server (calendar feed and phone reminders)",
    "events.err.title": "Give the event a title.",
    "events.err.date": "Pick a date.",
    "events.err.until": "The last date can't be before the first.",
    "events.err.amount": "Enter the cost as a number, like 85.50.",
    "feed.title": "Calendar feed",
    "feed.name": "{app} events",
    "feed.intro": "Subscribe to your events from Google Calendar, Outlook or Apple Calendar with a private address.",
    "feed.privacy": "This is off until you turn it on. When it's on, the server keeps a readable copy of each event's title, date and repeat (and amount, if you choose) so your calendar app can fetch it. Notes, categories and events you keep out stay encrypted. Anyone with the address can read the feed, so treat it like a password.",
    "feed.detail": "Each calendar entry shows",
    "feed.detail.title": "The title only",
    "feed.detail.amount": "The title and expected cost",
    "feed.start": "Turn on the calendar feed",
    "feed.started": "Calendar feed is on.",
    "feed.address": "Private feed address",
    "feed.copy": "Copy address",
    "feed.copied": "Address copied.",
    "feed.howTo": "Google Calendar: Other calendars, then From URL. Outlook: Add calendar, then Subscribe from web. Calendar apps check for changes every few hours.",
    "feed.reachable": "Google and Outlook fetch the feed from the internet, so this address must be reachable from outside your home network, for example through the Cloudflare Tunnel option.",
    "feed.demo": "Demo mode: this address is made up and nothing is published.",
    "feed.newAddress": "Get a new address",
    "feed.confirmNew": "Get a new address? The current one stops working, and you'll need to subscribe again in your calendar apps.",
    "feed.renewed": "New feed address ready. The old one no longer works.",
    "feed.stop": "Turn off",
    "feed.stopped": "Calendar feed is off and its copy on the server is deleted.",
    "dash.comingUp": "Coming up",
    "dash.comingUpNone": "Nothing in the next two weeks.",
    "dash.allEvents": "All events",
    "nav.settings": "Settings",
    "auth.signIn": "Sign in",
    "auth.demo": "Try the demo",
    "auth.demoNote": "The demo uses a made-up household and keeps nothing.",
    "auth.signOut": "Sign out",
    "auth.lock": "Lock",
    "auth.signedOut": "Sign in with your {app} account to continue.",
    "unlock.title": "Unlock {app}",
    "unlock.intro": "Your data is encrypted. Enter your passphrase to unlock it on this device.",
    "unlock.passphrase": "Passphrase",
    "unlock.submit": "Unlock",
    "unlock.working": "Unlocking…",
    "unlock.wrong": "That didn't work. Check it and try again, or use your recovery key.",
    "unlock.useRecovery": "Use my recovery key instead",
    "unlock.usePassphrase": "Use my passphrase instead",
    "unlock.recoveryKey": "Recovery key",
    "setup.title": "Create your passphrase",
    "setup.intro": "Your data is encrypted in this browser with a key that only your passphrase can unlock. Nobody else can read it, including whoever runs the server.",
    "setup.passphrase": "Passphrase",
    "setup.confirm": "Confirm passphrase",
    "setup.hint": "At least 12 characters. A few unrelated words work well.",
    "setup.tooShort": "Use at least 12 characters.",
    "setup.mismatch": "The two passphrases don't match.",
    "setup.create": "Create my encryption keys",
    "setup.working": "Creating keys…",
    "setup.recoveryTitle": "Save your recovery key",
    "setup.recoveryIntro": "If you forget your passphrase, this key is the only way back in. Print it or store it in a password manager. It won't be shown again.",
    "setup.recoveryConfirm": "I've saved my recovery key",
    "setup.copy": "Copy",
    "setup.copied": "Copied",
    "dashboard.title": "Dashboard",
    "kpi.label": "Key figures",
    "kpi.cashAvailable": "Left to spend this month",
    "kpi.spentToday": "Spent today",
    "kpi.monthToDate": "Spent this month",
    "kpi.netThisMonth": "Net this month",
    "kpi.ofBudget": "of {budget}",
    "kpi.dailyBudget": "daily budget {budget}",
    "status.title": "Budget status",
    "status.day": "Today",
    "status.week": "This week",
    "status.month": "This month",
    "status.green": "On track",
    "status.amber": "Close to budget",
    "status.red": "Over budget",
    "status.detail": "{spent} spent, {paced} expected so far",
    "pie.title": "Top categories this month",
    "pie.other": "Smaller categories",
    "pie.empty": "No spending yet this month.",
    "pie.summary": "Largest category: {name}, {amount} ({percent}).",
    "calendar.title": "Year at a glance",
    "calendar.metric": "Show",
    "calendar.metric.net": "Net cash flow",
    "calendar.metric.budget": "Spending against daily budget",
    "calendar.view": "View",
    "calendar.view3d": "3D",
    "calendar.view2d": "Grid",
    "calendar.reset": "Reset view",
    "calendar.instructions": "Arrow keys move between days. Page Up and Page Down change month. Home and End jump to the first and last day.",
    "calendar.dragHint": "Drag to rotate, scroll to zoom.",
    "calendar.noTransactions": "no transactions",
    "calendar.capped": "Bars are capped at {cap}; taller days are marked with a dot.",
    "calendar.summary": "{up} days up, {down} days down. Biggest day: {date}, {value}.",
    "calendar.selected": "{date}: {value}",
    "calendar.top": "Top transactions",
    "budgets.title": "Budgets",
    "budgets.pool": "Monthly pool",
    "budgets.poolHelp": "Take-home income minus fixed commitments. Every slider shares this amount.",
    "budgets.units": "Show every line in",
    "budgets.mode": "When one changes, adjust the others",
    "budgets.modeEqual": "Equally",
    "budgets.modeProportional": "By size",
    "budgets.period": "Period",
    "budgets.lock": "Lock {name}",
    "budgets.unlock": "Unlock {name}",
    "budgets.budget": "Budget",
    "budgets.actual": "Actual",
    "budgets.left": "{amount} left",
    "budgets.over": "{amount} over",
    "budgets.sliderLabel": "{name} budget",
    "budgets.sliderValue": "{amount}, {percent} of the pool. Actual so far {actual}.",
    "budgets.rebalanced": "{name} set to {amount}. Other unlocked budgets adjusted.",
    "budgets.help": "Click an amount to type an exact figure. Arrow keys change a budget by $1, Page Up and Page Down by $50, and Space locks or unlocks it. The $ / % switch picks how each line is shown, and a lock holds whichever is shown.",
    "budgets.total": "Total budgeted",
    "period.day": "Daily",
    "period.week": "Weekly",
    "period.month": "Monthly",
    "period.year": "Yearly",
    "import.title": "Import",
    "import.intro": "Download a CSV from your bank's website, then drop it here.",
    "import.drop": "Drop a bank CSV here",
    "import.choose": "Choose a file",
    "import.privacy": "The file is read in this browser. Only encrypted results are sent to the server.",
    "import.detected": "Recognised as {bank}.",
    "import.unverified": "This {bank} layout hasn't been checked against a real export yet, so look over the preview carefully.",
    "import.unknown": "This file's layout wasn't recognised. Tell {app} which columns to use.",
    "import.mapDate": "Date column",
    "import.mapDescription": "Description column",
    "import.mapAmount": "Amount column",
    "import.mapDateOrder": "Date order",
    "import.mapApply": "Use these columns",
    "import.account": "Account name",
    "import.summary": "{count} transactions found: {fresh} new, {duplicates} already imported, {errors} rows unreadable.",
    "import.confirm": "Import {count} new transactions",
    "import.done": "Imported {count} transactions.",
    "import.duplicate": "Already imported",
    "import.needsCategory": "Needs a category",
    "import.error": "Row {line}: {message}",
    "import.col.date": "Date",
    "import.col.description": "Description",
    "import.col.amount": "Amount",
    "import.col.category": "Category",
    "import.col.status": "Status",
    "import.new": "New",
    "settings.title": "Settings",
    "settings.appearance": "Appearance",
    "settings.mode": "Mode",
    "settings.palette": "Palette",
    "settings.language": "Language",
    "settings.data": "Your data",
    "settings.export": "Download a decrypted copy (JSON)",
    "settings.demoReset": "Reset the demo household",
    "settings.about": "About",
    "settings.license": "{app} is free software under the GNU Affero General Public License, version 3 or later.",
    "settings.version": "Version {version}",
    "mode.light": "Light",
    "mode.grey": "Grey",
    "mode.dark": "Dark",
    "mode.system": "Match system",
    "mode.toggle": "Mode: {mode}. Select to change.",
    "palette.default": "Default (teal and coral)",
    "palette.ocean": "Ocean (blue and orange)",
    "palette.forest": "Forest (green and magenta)",
    "palette.colorblind": "Colour-blind safe",
    "palette.contrast": "High contrast",
    "cat.housing": "Housing",
    "cat.groceries": "Groceries",
    "cat.dining": "Dining out",
    "cat.transport": "Transport",
    "cat.shopping": "Shopping",
    "cat.entertainment": "Entertainment",
    "cat.health": "Health",
    "cat.household": "Household",
    "cat.savings": "Savings",
    "cat.other": "Other",
    "cat.housing/mortgage": "Mortgage payment",
    "cat.housing/mortgage/interest": "Mortgage interest",
    "cat.housing/property-tax": "Property tax",
    "cat.housing/home-insurance": "Home insurance",
    "cat.housing/condo-fees": "Condo fees",
    "cat.housing/upkeep": "Maintenance and upkeep",
    "cat.housing/repairs": "Repairs",
    "cat.housing/rent": "Rent",
    "cat.housing/tenant-insurance": "Tenant insurance",
    "cat.housing/parking": "Parking",
    "cat.housing/utilities": "Utilities",
    "cat.housing/utilities/electricity": "Electricity",
    "cat.housing/utilities/gas": "Natural gas",
    "cat.housing/utilities/water": "Water and sewer",
    "cat.housing/utilities/internet": "Internet",
    "cat.housing/utilities/phone": "Phone",
    "cat.transport/loan": "Loan or lease payment",
    "cat.transport/loan/interest": "Financing interest",
    "cat.transport/maintenance": "Maintenance",
    "cat.transport/repairs": "Repairs",
    "cat.transport/insurance": "Insurance",
    "cat.transport/licensing": "Licensing and registration",
    "cat.transport/fuel": "Fuel or charging",
    "cat.transport/parking": "Parking and tolls",
    "cat.transport/transit": "Public transit",
    "cat.transport/rideshare": "Ride-share and taxi",
    "cat.dining/restaurants": "Restaurants",
    "cat.dining/coffee": "Coffee",
    "cat.dining/takeout": "Takeout and delivery",
    "cat.health/prescriptions": "Prescriptions",
    "cat.health/dental": "Dental",
    "cat.health/vision": "Vision",
    "cat.health/fitness": "Fitness",
    "cat.shopping/clothing": "Clothing",
    "cat.shopping/electronics": "Electronics",
    "cat.shopping/gifts": "Gifts",
    "cat.household/furniture": "Furniture",
    "cat.household/supplies": "Supplies",
    "cat.household/pets": "Pets",
    "cat.entertainment/subscriptions": "Subscriptions",
    "cat.entertainment/events": "Outings and events",
    "cat.entertainment/hobbies": "Hobbies",
    "budgets.subs": "Sub-categories of {name}",
    "budgets.subsHelp": "These split {name}'s {amount}. Moving one rebalances the others; the total stays the same.",
    "budgets.rest": "Everything else in {name}",
    "budgets.addSub": "New sub-category under {name}",
    "budgets.addUnder": "Where the new sub-category goes",
    "budgets.under": "Under {name}",
    "budgets.fromRecent": "Split by the last 3 months' spending",
    "budgets.fromRecentDone": "Split {name} by recent spending.",
    "budgets.addSubButton": "Add",
    "budgets.added": "Added {name} under {parent}.",
    "budgets.removeSub": "Remove {name}",
    "budgets.confirmRemove": "Remove “{name}”? Its transactions and budget move to {parent}.",
    "budgets.removed": "Removed {name}. Its transactions now sit under {parent}.",
    "budgets.nameTaken": "There's already a category with that name here.",
    "survey.title": "Set up your categories",
    "survey.intro": "Three quick questions so your budget starts with categories that fit. Skip any you like; you can change them later in Settings.",
    "survey.housing": "Your home",
    "survey.housing.own": "I own",
    "survey.housing.rent": "I rent",
    "survey.housing.family": "I live with family (no housing costs)",
    "survey.vehicle": "Vehicles",
    "survey.vehicle.none": "No vehicle",
    "survey.vehicle.owned": "Owned outright",
    "survey.vehicle.financed": "Financed (loan)",
    "survey.vehicle.leased": "Leased",
    "survey.pay": "Take-home pay (optional)",
    "survey.payAmount": "Amount per pay",
    "survey.payFrequency": "How often",
    "survey.pay.weekly": "Every week",
    "survey.pay.biweekly": "Every two weeks",
    "survey.pay.semimonthly": "Twice a month",
    "survey.pay.monthly": "Once a month",
    "survey.payHint": "Sets your monthly budget pool to about {amount}.",
    "survey.save": "Save and continue",
    "survey.skip": "Skip for now",
    "survey.saved": "Categories set up.",
    "survey.payInvalid": "Enter the amount as a number, like 2450.",
    "settings.household": "Household setup",
    "settings.householdHint": "Your answers decide which categories show. Categories you already use always stay.",
    "update.ready": "A new version of {app} is ready.",
    "update.reload": "Reload now",
    "update.later": "Later",
    "cat.income": "Income",
    "cat.transfers-in": "Transfers in",
    "cat.uncategorized": "Uncategorised",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.loading": "Loading…",
    "common.error": "Something went wrong: {message}",
    "auth.failed": "Sign-in didn't complete. Try again, or ask whoever runs this {app} server to check the Authentik settings.",
    "auth.expired": "The sign-in took too long and expired. Try again.",
    "auth.offline": "The {app} server can't be reached right now. You can still try the demo.",
    "auth.signedInAs": "Signed in as {name}",
    "import.sample": "Or try a made-up sample file:",
    "import.hasHeader": "The first row holds column names",
    "palette.custom": "Custom colours",
    "settings.customHint": "Choosing the budget or up colour also sets its complement, which you can then change.",
    "settings.color.positive": "Up days (money in)",
    "settings.color.negative": "Down days (money out)",
    "settings.color.budget": "Budget (top of each slider)",
    "settings.color.actual": "Actual (bottom of each slider)",
    "settings.deleteLabel": "To delete your account, type DELETE",
    "settings.deleteHint": "This removes your account and every record now. It cannot be undone.",
    "settings.delete": "Delete my account and data",
    "common.saving": "Saving…",
    "common.demoBanner": "Demo mode: made-up data, nothing is saved.",
    "nav.year": "Year",
    "pie.open": "Show {name} sub-categories",
    "pie.back": "Back to {name}",
    "pie.all": "all categories",
    "dash.period": "Period",
    "dash.prevMonth": "Previous month",
    "dash.nextMonth": "Next month",
    "dash.thisMonth": "This month",
    "dash.view": "Show",
    "dash.view.month": "One month",
    "dash.view.outlook": "3-month outlook",
    "dash.bigPicture": "Big picture",
    "dash.today": "Today",
    "dash.yearSoFar": "{year} so far",
    "dash.emptyDay": "No spending today.",
    "dash.emptyMonth": "No spending in {month}.",
    "dash.emptyYear": "No spending in {year}.",
    "dash.wholeYear": "See the whole year",
    "dash.outlook": "3-month outlook",
    "dash.budget": "Budget",
    "dash.spent": "Spent",
    "dash.scheduled": "Scheduled events",
    "dash.left": "Left",
    "dash.over": "Over budget by",
    "dash.planned": "Not started yet: showing the budget plan.",
    "year.choose": "Year",
    "year.previous": "Previous year",
    "year.next": "Next year",
    "year.thisYear": "This year",
    "year.donut": "Spending in {year}",
    "year.byCategory": "By category",
    "year.table": "Month by month",
    "year.tableHint": "Each month is compared with your current budget plan.",
    "year.category": "Category",
    "year.all": "All spending",
    "year.caption": "{name}, budget and spending by month in {year}",
    "year.month": "Month",
    "year.notYet": "Not yet",
    "year.over": "{amount} over",
    "year.total": "Total ({count} months)",
    "kpi.ofBudgetScheduled": "of {budget}, after {scheduled} in scheduled events",
    "budgets.scheduled": "Scheduled",
    "budgets.sliderScheduled": "Scheduled events {amount}.",
    "events.paid": "Paid {date}",
    "events.categoryHint": "A cost counts toward this category's budget (or Other, with no category) until a matching payment shows up in your transactions.",
    "push.when.today": "today",
    "push.when.tomorrow": "tomorrow",
    "push.when.days": "in {days} days",
    "push.reminders": "{count} reminder(s) {when}.",
    "push.remindersNamed": "Coming up {when}: {list}.",
    "push.more": "and {count} more",
    "push.test": "Test from {app}: phone notifications are working.",
    "nav.notifications": "Notifications",
    "notify.unread": ", {count} new",
    "notify.now": "Needs your attention",
    "notify.none": "Nothing needs your attention right now.",
    "notify.dismiss": "Dismiss",
    "notify.dismissNamed": "Dismiss: {text}",
    "notify.dismissAll": "Dismiss all",
    "notify.dismissed": "Dismissed.",
    "notify.dismissedAll": "Dismissed all notifications.",
    "notify.attention": "Attention:",
    "notify.type.bills": "Bills and events",
    "notify.type.bills.hint": "unpaid bills in the next week, and events today or tomorrow",
    "notify.type.budgets": "Budgets",
    "notify.type.budgets.hint": "a category that is over, or 90% spent or scheduled",
    "notify.show": "What to show",
    "notify.billDue": "{title}: {amount} due {date}.",
    "notify.billOverdue": "{title}: {amount} was due {date} and no matching payment has shown up yet.",
    "notify.eventToday": "{title} is today.",
    "notify.eventTomorrow": "{title} is tomorrow.",
    "notify.budgetOver": "{name} is over budget: {used} of {budget} spent or scheduled this month.",
    "notify.budgetNear": "{name} is nearly used up: {used} of {budget} spent or scheduled this month.",
    "push.title": "Phone notifications (ntfy)",
    "push.intro": "Get reminders on your phone through your own ntfy server: one message a day about upcoming events, and an alert when a budget goes over.",
    "push.privacy": "Turning this on lets the server read what it needs to send them: the dates of your events (not those kept off the server) and, if you allow it below, their titles and amounts. Budget alerts are worked out on this device and sent only in the wording you choose.",
    "push.server": "ntfy server address",
    "push.serverHint": "Your own ntfy server, or https://ntfy.sh.",
    "push.topic": "Topic",
    "push.topicHint": "Subscribe to this topic in the ntfy app. On a public server, anyone who knows the topic can read it, so keep the random one or use an access token.",
    "push.token": "Access token (optional)",
    "push.tokenHint": "Needed if your ntfy server requires sign-in. It is stored encrypted and never shown again.",
    "push.tokenKept": "Saved; leave blank to keep it",
    "push.tokenRemove": "Remove the saved token",
    "push.tokenRemoving": "The token will be removed when you save",
    "push.detail": "What pushes may say",
    "push.detail.generic": "Just counts, like “2 reminders tomorrow” (most private)",
    "push.detail.titles": "Event titles and budget names",
    "push.detail.amounts": "Titles and amounts",
    "push.remindHour": "Daily reminder at",
    "push.leadDays": "Remind about events",
    "push.lead.same": "the same day",
    "push.lead.days": "{count} day(s) ahead",
    "push.quiet": "Quiet hours (alerts wait until they end)",
    "push.quietStart": "From",
    "push.quietEnd": "Until",
    "push.digest": "Hold alerts for the daily reminder instead of sending them straight away",
    "push.timeZone": "Times are in {zone}, this device's time zone.",
    "push.start": "Turn on phone notifications",
    "push.save": "Save changes",
    "push.started": "Phone notifications are on.",
    "push.saved": "Saved.",
    "push.sendTest": "Send a test",
    "push.testSent": "Test sent. Check your phone.",
    "push.stop": "Turn off",
    "push.stopped": "Phone notifications are off. The server has forgotten the settings and schedule.",
    "push.error": "Something went wrong: {message}",
    "push.demo": "The demo never sends anything.",
    "push.alert.generic": "A budget category is over for this month.",
    "push.alert.titles": "{name} is over budget this month.",
    "push.alert.amounts": "{name} is over budget this month: {used} of {budget}.",
    "nav.purchases": "Large purchases",
    "cat.purchases": "Large purchases",
    "notify.open.bills": "Events",
    "notify.open.budgets": "Budgets",
    "notify.open.goals": "Large purchases",
    "notify.type.goals": "Large purchases",
    "notify.type.goals.hint": "a goal that will miss its date, or one fully saved for",
    "notify.goalReady": "{name} is fully saved for ({amount}). Mark it as bought when you buy it.",
    "notify.goalBehind": "{name} is behind: at the current pace it will be ready by {projected}, not {target}.",
    "notify.goalStalled": "{name} is getting nothing this month, so it won't be ready by {target}.",
    "notify.later": "Debts, people and security notifications will join these as those features arrive.",
    "events.fromPurchase": "This loan payment comes from a large purchase and is updated whenever that purchase changes. To change it, edit the purchase:",
    "budgets.purchasesLine": "Set aside for large purchases. This line stays locked so the other sliders work around it.",
    "budgets.purchasesOpen": "Change it on the Large purchases page",
    "budgets.allDollars": "Dollars ($)",
    "budgets.allPercent": "Percent of pool (%)",
    "budgets.unitSwitch": "Show {name} as a percentage",
    "budgets.lockedDollars": "$ locked",
    "budgets.lockedPercent": "% locked",
    "budgets.fixedLock": "Held by your large purchase goals",
    "budgets.typeAmount": "{name} {amount}, type an exact amount",
    "budgets.typeDollars": "{name} budget in dollars",
    "budgets.typePercent": "{name} budget as a percentage",
    "budgets.subsToggle": "{name} sub-categories ({count})",
    "budgets.goalsToggle": "{name} goals ({count})",
    "budgets.goals": "Goals under {name}",
    "budgets.noGoals": "Nothing is being saved for yet.",
    "budgets.goalShare": "{amount} this month",
    "budgets.goalBy": "by {date}",
    "nav.groups": "Groups",
    "cat.fronted": "Fronted for groups",
    "groups.intro": "Track money you front for others, like a shared phone plan or a trip, and get it back. Groups stay private to you; nobody in them is notified or signed up.",
    "groups.list": "Your groups",
    "groups.none": "No groups yet. Create one below.",
    "groups.new": "New group",
    "groups.name": "Group name",
    "groups.namePlaceholder": "Family phone plan",
    "groups.people": "Other people",
    "groups.peopleHelp": "Names separated by commas, for example: Sam, Jo, Kim. You are added automatically.",
    "groups.create": "Create group",
    "groups.created": "Created {name}.",
    "groups.you": "You",
    "groups.owedShort": "Owed to you: {amount}",
    "groups.oweShort": "You owe {amount}",
    "groups.settled": "All settled",
    "groups.balances": "Who owes what",
    "groups.owesYou": "{name} owes you {amount}",
    "groups.youOwe": "You owe {name} {amount}",
    "groups.isSettled": "{name} is settled up",
    "groups.markPaid": "Mark as paid",
    "groups.paidRecorded": "Recorded {amount} from {name}.",
    "groups.between": "Between others",
    "groups.pays": "{from} pays {to} {amount}",
    "groups.reminder": "Reminder for {name}",
    "groups.reminderLabel": "Reminder message for {name}",
    "groups.reminderHello": "Hi {name}, for {group} you owe me {amount}:",
    "groups.reminderThanks": "Thanks!",
    "groups.reminderHint": "Copy it into a text or email. {app} never sends it for you.",
    "groups.copy": "Copy message",
    "groups.copied": "Copied.",
    "groups.addExpense": "Add an expense",
    "groups.addExpenseButton": "Add expense",
    "groups.what": "What",
    "groups.amount": "Amount",
    "groups.date": "Date",
    "groups.paidBy": "Paid by",
    "groups.repeat": "Repeats",
    "groups.once": "Once",
    "groups.split": "Split",
    "groups.split.equal": "Equally",
    "groups.split.shares": "By shares",
    "groups.split.percent": "By percent",
    "groups.split.exact": "Exact amounts",
    "groups.part.shares": "Shares for {name}",
    "groups.part.percent": "Percent for {name}",
    "groups.part.exact": "Amount for {name}",
    "groups.link": "Paid with",
    "groups.linkNone": "Not linked to a transaction",
    "groups.linkHelp": "Linking the payment takes the others' shares out of your own spending.",
    "groups.recurringHelp": "Each due date is matched to your payment automatically, and the others' shares are taken out of your own spending.",
    "groups.err.amount": "Enter what it was for and an amount.",
    "groups.err.nobody": "Pick at least one person to split it with.",
    "groups.err.percent": "The percentages need to add up to 100.",
    "groups.err.exact": "The amounts need to add up to {amount}.",
    "groups.expenseAdded": "Added {name}, {amount}.",
    "groups.expenses": "Expenses",
    "groups.noExpenses": "No expenses yet.",
    "groups.yourShare": "Your share",
    "groups.actions": "Actions",
    "groups.repeats": "repeats",
    "groups.linked": "linked",
    "groups.delete": "Delete",
    "groups.deleteExpense": "Delete {name}",
    "groups.confirmDeleteExpense": "Delete “{name}”?",
    "groups.recurring": "Repeating bills",
    "groups.recurringLine": "{name}, {amount}, {repeat} from {from}",
    "groups.ended": "ended {date}",
    "groups.stop": "Stop repeating",
    "groups.stopped": "{name} stops repeating after today.",
    "groups.payments": "Repayments",
    "groups.paymentLine": "{from} paid {to} {amount} on {date}",
    "groups.undo": "Undo",
    "groups.undoPaymentLabel": "Undo {amount} from {from}",
    "groups.members": "People",
    "groups.addMember": "Add a person",
    "groups.add": "Add",
    "groups.remove": "Remove",
    "groups.removeMember": "Remove {name}",
    "groups.deleteGroup": "Delete this group",
    "groups.confirmDelete": "Delete “{name}” and all its expenses and repayments?",
    "groups.deleted": "Deleted {name}.",
    "groups.offers": "Repayments to check",
    "groups.offer": "{name} sent you {amount} on {date}. Record it as a repayment for {group}?",
    "groups.offerYes": "Record repayment",
    "groups.offerNo": "Not a repayment",
    "groups.dashOwed": "{amount} is owed to you in your groups.",
    "groups.dashOpen": "Open Groups",
    "groups.paidYou": "{from} paid you {amount} on {date}",
    "groups.youPaid": "You paid {to} {amount} on {date}",
    "groups.youPaidRecorded": "Recorded {amount} you paid {name}.",
    "groups.showAll": "Show all {count}",
    "groups.showFewer": "Show fewer",
    "purchases.intro": "Enter what you want to buy, its price and when. Saving up sets money aside every month on a locked budget line. Financing adds the loan payment to your calendar and budget from the purchase date.",
    "purchases.setAside": "Set aside each month",
    "purchases.auto": "What your goals need: {amount} this month",
    "purchases.autoOn": "Following what your goals need.",
    "purchases.fixed": "A fixed amount (goals share it, highest priority first)",
    "purchases.fixedAmount": "Amount per month",
    "purchases.line": "The Large purchases budget line holds {amount} this month.",
    "purchases.openBudgets": "See budgets",
    "purchases.noRoom": "Only {fit} of {wanted} fits, because the rest of your budget is locked or at $0. Lower-priority goals will take longer.",
    "purchases.short": "Your goals need {need} a month to stay on schedule, so lower-priority goals will be pushed out.",
    "purchases.saving": "Saving up",
    "purchases.noSaves": "Nothing being saved for yet. Add one below.",
    "purchases.priorityHelp": "Listed by priority. When money is short, goals higher on the list are funded first.",
    "purchases.target": "{price} by {date}",
    "purchases.progressLabel": "Saved toward {name}",
    "purchases.progress": "{saved} saved of {price} ({percent})",
    "purchases.monthly": "Needs {need} a month; gets {funded} this month.",
    "purchases.projected": "At this pace, ready by {date}.",
    "purchases.never": "At this pace it won't be ready.",
    "purchases.pace.complete": "Fully saved",
    "purchases.pace.ahead": "Ahead",
    "purchases.pace.on-track": "On track",
    "purchases.pace.behind": "Behind",
    "purchases.pace.overdue": "Past its date",
    "purchases.addSaved": "Add to saved",
    "purchases.addSavedLabel": "Amount to add to what is saved for {name}",
    "purchases.added": "Added {amount} to {name}.",
    "purchases.edit": "Edit {name}",
    "purchases.editShort": "Edit",
    "purchases.moveUp": "Move {name} up in priority",
    "purchases.moveUpShort": "Up",
    "purchases.moveDown": "Move {name} down in priority",
    "purchases.moveDownShort": "Down",
    "purchases.markBought": "Mark as bought",
    "purchases.markedBought": "{name} marked as bought. It no longer takes money from the budget.",
    "purchases.delete": "Delete {name}",
    "purchases.confirmDelete": "Delete {name}?",
    "purchases.confirmDeleteLoan": "Delete {name} and its loan payments from the calendar?",
    "purchases.deleted": "Deleted {name}.",
    "purchases.financed": "Financed",
    "purchases.financeSummary": "{price}, {down} down, bought {date}",
    "purchases.payment": "{amount} a month for {count} months, starting {first}",
    "purchases.interest": "Total interest {interest}; it costs {total} in all, paid off by {last}.",
    "purchases.made": "{made} of {count} payments made.",
    "purchases.financeBudget": "The payment is on your Events calendar and counts toward its budget category until each payment shows up in your transactions.",
    "purchases.bought": "Bought",
    "purchases.boughtItem": "{name}, {price}, bought {date}",
    "purchases.add": "Add a large purchase",
    "purchases.editTitle": "Edit {name}",
    "purchases.name": "What is it?",
    "purchases.price": "Price",
    "purchases.date": "When to buy it",
    "purchases.mode": "How will you pay?",
    "purchases.mode.save": "Save up for it",
    "purchases.mode.finance": "Finance it",
    "purchases.savedSoFar": "Saved so far",
    "purchases.down": "Down payment",
    "purchases.rate": "Interest rate (% a year)",
    "purchases.term": "Loan length",
    "purchases.termMonths": "{count} months",
    "purchases.category": "Budget category for the payments",
    "purchases.categoryHint": "For a vehicle, Transport › Loan or lease payment. With no category, payments count under Other.",
    "purchases.previewSave": "That is {amount} a month from now.",
    "purchases.previewFinance": "That is {amount} a month for {count} months, with {interest} in interest.",
    "purchases.addButton": "Add purchase",
    "purchases.saved": "Saved {name}.",
    "purchases.paymentTitle": "Loan payment: {name}",
    "purchases.err.name": "Give it a name.",
    "purchases.err.price": "Enter a price above $0.",
    "purchases.err.date": "Choose a date.",
    "purchases.err.saved": "Enter the amount as a number, or leave it blank.",
    "purchases.err.rate": "Enter a rate between 0 and 40%.",
};
//# sourceMappingURL=en.js.map